<template>
  <div class="meet9ingnotice">
    <Header style="width:100%" :title="$t('m.NeetingNotice')"></Header>
    <div class="row">
      <div class="left">
        {{$t('m.MeetingName')}}
      </div>
      <div class="right">
        {{$t('m.ReportToJiangsuMonday')}}
      </div>
    </div>
    <div class="row">
      {{$t('m.ClickConnectJionMeeting')}} <span class="color" style="margin-left:0.1rem;">rongbin@sina.com</span>
    </div>
    <div class="warp">
      <img alt="" src="../../assets/images/public/erweima.png">
      <div style="line-height:0.20rem;">{{$t('m.ScanQRCodeJionMeeting')}}</div>
    </div>
    <div class="row">
      <div class="left">{{$t('m.MeetingNoColon')}}</div>
      2010348478
    </div>
    <div class="row">
      <div class="left">{{$t('m.Password')}}</div>
      123456
    </div>
    <div class="row">
      <div class="left">{{$t('m.StartTimeColon')}}</div>
      2018-03-21 14:30
    </div>
    <div class="row">
      <div class="left">{{$t('m.MeetingDuration')}}</div>
      {{$t('m.Minute30')}}
    </div>
    <div class="row">
      <div class="left">{{$t('m.MeetingSponsor')}}</div>
      Robin
    </div>
    <div>
      <div class="left">{{$t('m.MeetingBrief')}}</div>
      <div class="content">
        {{$t('m.NoticeDesc')}}
      </div>
      <div style="clear:both"></div>
    </div>
    <div class="row bgc" style="color:#fff;text-align:center;margin:0 -0.15rem;font-size:0.17rem">
      {{$t('m.ClickDownloadTerminalSoftware')}}
    </div>
  </div>
</template>
<script>
  import Header from '../header/header'

  export default {
    name: "meetingnotice",
    data() {
      return {}
    },
    components: {
      Header
    }
  }
</script>
<style scoped>
  .meet9ingnotice {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.15rem;
    font-size: 0.14rem;
    line-height: 0.49rem;
  }

  .row {
    height: 0.49rem;
    border-bottom: 1px solid #D7D5D5;
  }

  .left {
    float: left;
    width: 1.05rem;
    text-align: left;
  }

  .warp {
    height: 2.37rem;
    padding: 0.1rem 0;
    text-align: center;
  }

  .content {
    line-height: 0.28rem;
    width: 1.7rem;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/content/meetnotice.vue